import React from 'react';
import { SectionZone } from '@/components/SectionZone';
import { GlobalSettingsInterface } from '@/types';
import { Stack as SanityStack } from '@/types/SanityTypes';

const Stack = ({
  stackItems,
  globalSettings,
}: {
  stackItems: SanityStack[];
  globalSettings: GlobalSettingsInterface[];
}) => {
  return (
    stackItems &&
    stackItems.map((section, index) => (
      <div
        key={index}
        className='flex flex-col gap-4'
      >
        <SectionZone
          key={index}
          section={section}
          globalSettings={globalSettings}
        />
      </div>
    ))
  );
};

export default Stack;
